import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import { marked } from 'marked';

import { useOrderContext } from '@hooks';
import PrimaryButton from '@components/PrimaryButton';
import MatchChip from '@components/MatchChip';
import ChevronDown from '@components/Icons/ChevronDown';
import { MATCH_CHIP_TYPES } from '@constants';
import fire from '@assets/local_fire_department.svg';

import InputNumber from '../InputNumber';
import { useStyles, useStylesButton } from './styles';

const ProductCard = ({ product, promoted }) => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const { order, setOrder } = useOrderContext();

  const currentProductAlreadyOrdered = order.find(
    orderItem => orderItem.id === product.id,
  );

  const [isExpand, updateExpand] = useState(false);
  const [quantityCocktail, setQuantityCocktail] = useState(0);

  const showDetails = async () => {
    updateExpand(!isExpand);
  };

  const addOrder = qtyProduct => {
    if (qtyProduct === 1) {
      setQuantityCocktail(1);
    }

    let filteredOrder = order.find(el => el.id === product.id);

    if (filteredOrder) {
      filteredOrder = Object.assign(filteredOrder, {
        qty: qtyProduct,
      });
    } else {
      if (product.promotedProduct && promoted) {
        product.promoted = true;
      }
      filteredOrder = Object.assign(product, {
        qty: 1,
      });
    }

    let removedOrders = order.filter(el => el.id !== product.id);
    let finalOrders = removedOrders.concat(filteredOrder);

    const idxZeroQtyItem = finalOrders.findIndex(
      orderItem => orderItem.qty === 0,
    );

    if (idxZeroQtyItem >= 0) {
      finalOrders.splice(idxZeroQtyItem, 1);
      setOrder(finalOrders);
      return;
    }

    setOrder(finalOrders);
  };

  const handleButtonClick = operator => () => {
    let currentQty =
      operator === 'plus' ? quantityCocktail + 1 : quantityCocktail - 1;
    if (currentProductAlreadyOrdered?.qty) {
      currentQty =
        operator === 'plus'
          ? currentProductAlreadyOrdered.qty + 1
          : currentProductAlreadyOrdered.qty - 1;
    }

    addOrder(currentQty);

    if (operator === 'plus' && currentProductAlreadyOrdered.qty) {
      setQuantityCocktail(currentProductAlreadyOrdered.qty);
      return;
    }
    if (operator === 'plus' && !currentProductAlreadyOrdered.qty) {
      setQuantityCocktail(quantityCocktail + 1);
      return;
    }

    if (currentProductAlreadyOrdered.qty) {
      setQuantityCocktail(currentProductAlreadyOrdered?.qty);
    }
    if (!currentProductAlreadyOrdered.qty) {
      setQuantityCocktail(quantityCocktail - 1);
    }
  };

  const price = product.priceIncludingTax.toFixed(2);
  const priceProduct = `€ ${price}`;
  const showLongDescription =
    !product.longDescription && !product.product.allergens;

  const chevronMoreInfoButton = {
    transform: isExpand ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform .3s ease',
  };
  const commaSeparatedAllergenes = product.product.allergens
    ?.map(allergen => ` ${allergen}`)
    .toString();

  const sessionString = localStorage.getItem('session');
  const sessionParsed = JSON.parse(sessionString);
  return (
    <div className={classes.card}>
      <div className={classes.cardTop}>
        {product.match && !promoted ? (
          <MatchChip
            match={product.match * 100}
            type={MATCH_CHIP_TYPES.PRODUCT_CARD}
          />
        ) : promoted &&
          sessionParsed.visit.promoteProductsTestGroup === 'a' &&
          !product.match ? (
          <span
            style={{
              display: 'flex',
              fontFamily: 'Roboto',
              fontWeight: '700',
              fontSize: '10px',
              lineHeight: '23px',
              flexDirection: 'row',
              backgroundColor: '#FF6107',
              position: 'absolute',
              right: '20px',
              top: '0px',
              color: '#fff',
              borderRadius: '0 0 5px 5px',
              textTransform: 'uppercase',
              padding: '0 .5rem',
            }}
          >
            <img src={fire} alt="lit" />
            Popular
          </span>
        ) : product.match &&
          promoted &&
          sessionParsed.visit.promoteProductsTestGroup === 'a' ? (
          <span
            style={{
              display: 'flex',
              fontFamily: 'Roboto',
              fontWeight: '700',
              fontSize: '10px',
              lineHeight: '23px',
              flexDirection: 'row',
              backgroundColor: '#0894E2',
              position: 'absolute',
              right: '20px',
              top: '0px',
              color: '#fff',
              borderRadius: '0 0 5px 5px',
              textTransform: 'uppercase',
              padding: '0 .5rem',
            }}
          >
            <img src={fire} alt="lit" />
            Promotion
          </span>
        ) : null}
        <div className={classes.cardUpper}>
          <img className={classes.cardImg} src={product.icon} alt="cocktail" />
          <div className={classes.cardInfo}>
            <Typography className={classes.cardTitle}>
              {product.name}
            </Typography>
            <Typography className={classes.cardPrice}>
              {priceProduct}
            </Typography>
          </div>
        </div>
        <Typography className={classes.shortDescription}>
          {product.shortDescription}
        </Typography>
      </div>

      <Collapse in={isExpand}>
        <div className={classes.collapseInner}>
          {product?.longDescription ? (
            <div className={classes.descriptionWrapper}>
              <Typography className={classes.longDescription}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: marked.parse(
                      product.longDescription?.replace(/\n/g, '<br />'),
                    ),
                  }}
                />
              </Typography>
            </div>
          ) : (
            <div className={classes.desriptionNotAvailable}>No description</div>
          )}
          {product?.product.allergens && (
            <div>
              <div className={classes.divider} />
              <div>
                <Typography className={classes.heading}>Allergens</Typography>
                <div>
                  <Typography className={classes.allergenText}>
                    {commaSeparatedAllergenes}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </div>
      </Collapse>

      <div className={classes.cardBottom}>
        <button
          onClick={showDetails}
          className={classes.moreInfoButton}
          disabled={showLongDescription}
          style={showLongDescription ? { visibility: 'hidden' } : {}}
        >
          <span className={classes.moreInfoButtonText}>
            {isExpand ? 'Hide' : 'More'} info
          </span>
          <div style={chevronMoreInfoButton}>
            <ChevronDown />
          </div>
        </button>
        {quantityCocktail > 0 || currentProductAlreadyOrdered?.qty > 0 ? (
          <InputNumber
            quantityCocktail={
              quantityCocktail || currentProductAlreadyOrdered.qty
            }
            handleButtonClick={handleButtonClick}
          />
        ) : (
          <PrimaryButton
            text="+"
            classesButton={classesButton}
            handleClick={() => addOrder(1)}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
